import styled from 'foundations-theming/utils';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledContainer = styled.div.withConfig({
  displayName: "ToolDescription__StyledContainer",
  componentId: "sc-6r15jj-0"
})(["color:", ";margin-left:0 !important;"], ({
  theme
}) => theme.color['do-not-use-slinky']);
export default function ToolDescription({
  children
}) {
  return /*#__PURE__*/_jsx(StyledContainer, {
    children: /*#__PURE__*/_jsx(Small, {
      children: children
    })
  });
}